import { combineReducers } from 'redux';

// Front
import Layout from './layout/reducer';

// Authentication Module
import Login from './auth/login/reducer';
import Forget from './auth/forgetpwd/reducer';

import User from "./user/reducer";
import Role from "./role/reducer";
import Profile from "./profile/reducer";
import General from "./general/reducer";
import Dashboard from './dashboard/reducer';
import Inquiry from './inquiry/reducer';
// import Setting from './setting/reducer';
import Permission from './permission/reducer';
import Support from './support/reducer';
import Vendors from './vendors/reducer';
import ReuseableReducer from './setting/reducer';
import Service from './service/reducer';
import Notification from './notification/reducer';
import DebitNote from './debitNote/reducer';
import Register from './auth/register/reducer';
import Branch from './branch/reducer';
import Advert from './advert/reducer';
import Accessory from './accessory/reducer';
import LoanCalculate from './loanCalculator/reducer';
import Credit from './credit/reducer';

const rootReducer = combineReducers({

    // public
    Layout,

    // Authentication
    Login,
    Register,
    Forget,
    General,
    Permission,
    // setting
    ReuseableReducer,
    User,
    Profile,
    Role,
    Dashboard,
    Inquiry,
    Support,
    Branch,
    Advert,
    Accessory,
    LoanCalculate,
    Credit,
    Vendors,
    DebitNote,
    // Service
    Service,
    Notification
});

export default rootReducer;